<div *ngIf="showMe">
    <tds-modal show="true" (tdsClose)="closeDialog()" header="Comments" size="md">
        <span slot="body">
            <h2>Comments for Assignment nr: {{assignmentNumber}}</h2>
            <div *ngIf="isAllowedToEditComments()">
                <h3>Add Comment</h3>
                <tds-textarea
                    [(ngModel)]="commentInput"
                    ngDefaultControl
                    rows="3"
                    state="default"
                    label="Leave a comment"
                    helper=""
                    label-position="inside"
                    placeholder=""
                    max-length="2000">
                </tds-textarea>
                <div style="padding:5px;">
                    <tds-button
                        type="submit"
                        variant="primary"
                        size="lg"
                        text="Submit"
                        [disabled]="!isValuesSet()"
                        (click)="addComment(commentInput)">
                            <tds-icon slot="icon" class="tds-btn-icon" size="20px" name="send"></tds-icon>
                    </tds-button>
                </div>
            </div>
            <h3>Comment history</h3>
            <div style="height: 200px;overflow-y: scroll;">
                <div *ngIf="comments.length > 0">
                    <div *ngFor="let comment of comments">
                        <div style="margin-bottom: 12px; color: #041e42;">
                            <h4 style="position: relative;">{{comment.name}}
                            <tds-icon *ngIf="loggedUser.id == comment.globalId || loggedUser.role == 'Std HRAdmin'"
                                (click)="deleteComment(comment.commentId)"
                                style="position: absolute; cursor: pointer; font-size: 16px; margin-top: 0px;
                                    margin-left: 10px; color:red;"
                                name="trash"
                                size="24px">
                            </tds-icon>
                            </h4>
                            <div><strong>{{comment.department}}</strong></div>
                            <div><strong>{{comment.role}}</strong></div>
                            <div><strong>{{comment.email}}</strong></div>
                            <div><strong>{{comment.commentDate | date:'medium'}}</strong></div>
                        </div>
                        <div style="word-wrap: normal">
                            <div>{{comment.commentText}}</div>
                        </div>
                        <hr>
                    </div>
                </div>
                <div *ngIf="comments?.length == 0">No Comments To Show.</div>
                <div *ngIf="showLoading" class="page-spinner-container" >
                    <div class="page-spinner tds-headline-06 ">
                        <tds-spinner size="lg" variant="standard" style="margin-top: 64px;"></tds-spinner>
                    </div>      
                </div>
            </div>
        </span>

        <span slot="actions">
            <tds-button
                data-dismiss-modal
                type="button"
                variant="primary"
                size="md"
                text="Close"
                (click)="closeDialog()">
            </tds-button>
        </span>
    </tds-modal>
</div>